import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _extends from 'babel-runtime/helpers/extends';

import XLSX from 'xlsx';
import { format } from 'date-fns';

export default {
  name: 'ExportBtn',

  props: {
    // 按钮配置
    params: {
      type: Object,
      default: function _default() {}
    },
    // 表格标题
    title: {
      type: String,
      required: true,
      default: 'Sheet'
    },

    label: {
      type: String,
      default: '导出报表'
    },

    header: {
      type: Object,
      required: true
    },

    sheet: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    // 接口请求，返回一个 Promise
    request: {
      type: Function
    },

    // 数据加工函数
    // cookResponse(res, flag)
    // res: 接口返回的数据
    // flag：是否是导出报表数据加工，默认为 true
    cookResponse: {
      type: Function
    },

    query: {
      type: Object,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      loading: false,
      innerSheet: []
    };
  },


  computed: {
    innerParams: function innerParams() {
      return _extends({
        icon: 'el-icon-fa-download',
        type: 'primary'
      }, this.params);
    }
  },

  watch: {
    sheet: function sheet(val) {
      this.innerSheet = val;
    }
  },

  mounted: function mounted() {
    this.innerSheet = this.sheet;
  },


  methods: {
    handleClick: function handleClick() {
      this.innerSheet = [];
      this.loading = true;
      if (this.request) {
        this.getSheetData(_extends({ page: 1, page_size: 2000 }, this.query));
      } else {
        this.$emit('export');
      }
    },
    exportSheet: function exportSheet() {
      var _this = this;

      var sheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.innerSheet;

      this.loading = false;
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet([this.header], { skipHeader: 1 });
      // todo https://github.com/SheetJS/js-xlsx/issues/1364
      sheet.forEach(function (item) {
        // 保证sheet与header顺序一致
        var newItem = {};
        _Object$keys(_this.header).forEach(function (key) {
          newItem[key] = item[key] ? item[key] : '-';
        });
        XLSX.utils.sheet_add_json(ws, [newItem], {
          skipHeader: true,
          origin: -1
        });
      });
      XLSX.utils.book_append_sheet(wb, ws, this.title);
      var fileName = this.title + '_' + format(new Date(), 'YYYYMMDDHHmmss') + '.xlsx';
      XLSX.writeFile(wb, fileName);
      this.innerSheet = [];
    },
    exportError: function exportError(msg) {
      this.loading = false;
      this.$message({
        message: msg || '导出失败，请重试',
        type: 'warning'
      });
    },
    getSheetData: function getSheetData(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                params = _extends({ page: 1, page_size: 2000 }, params);
                _context.next = 4;
                return _this2.request(params);

              case 4:
                res = _context.sent;
                list = _this2.cookResponse(res, true);

                _this2.innerSheet = _this2.innerSheet.concat(list);
                if (list.length === 0) {
                  _this2.exportSheet(_this2.innerSheet);
                } else {
                  _this2.getSheetData(_extends({}, params, { page: params.page + 1 }));
                }
                _context.next = 15;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);
                _this2.innerSheet = [];
                _this2.exportError(_context.t0.message);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 10]]);
      }))();
    }
  }
};